import Form from '../component/um/usergroup/Form'

import useTranslate from '../i18n/useTranslate'
import { useEffect, useRef, useState } from 'react'
import { useHistory } from 'react-router-dom'
import Dialog, { DialogType } from '../control/dialog/dialog'
import { Typography, Grid, makeStyles, Paper, Container } from '@material-ui/core'
import useEditUsergroup, { FormInitial, FormType } from '../services/um/useEditUsergroup'
import { useParams } from 'react-router-dom'
import useAuthenStore from '../stores/authen/authenStore'

const UsergroupAdd = () => {
    const translate = useTranslate()
    const classes = useStyles()
    const params = useParams<{ id: string }>()
    const authenStore = useAuthenStore()
    const history = useHistory()
    const { putOfficer, officerInfo } = useEditUsergroup(params.id)

    const [configDialog, setConfigDialog] =
        useState<Pick<DialogType, 'title' | 'content' | 'type' | 'onClickConfirm' | 'onAfterClose'>>()
    const [initialUploadFile, setInitialUploadFile] = useState<any>()
    const dialogTwoRef = useRef<Record<string, Function>>()
    const onRefDialogTwo = (func: Record<string, Function>) => {
        dialogTwoRef.current = func
    }

    const topicInitial = [
        {
            id: undefined,
            no: '',
            name_th: '',
            name_en: '',
        },
    ]

    const initialUpload = async (initDocument?: FormInitial['documentInfo']) => {
        setInitialUploadFile(initDocument)
    }

    const initialValue = officerInfo && {
        ...officerInfo,
        irb: authenStore.profile.irb,
        userGroupID: officerInfo.usergroupID,
        cunetID: officerInfo.cunet ? '1' : '2', //1 is cunet  2 is ภายนอก
        positionID: officerInfo.position?.id ? officerInfo.position.id.toString() : '7', //ถ้าส่งเป็น null คือไม่ระบุ
        positionOtherTH: officerInfo.position?.name.th,
        positionOtherEN: officerInfo.position?.name.en,
        titleID: officerInfo.title?.id?.toString(),
        titleOtherTH: officerInfo.title?.name.th,
        titleOtherEN: officerInfo.title?.name.en,
        signatureTH: officerInfo?.signatureTH || null,
        signatureEN: officerInfo?.signatureEN || null,
        isBothIrb: officerInfo.isBothIrb,
    }

    const save = async (values: any) => {
        const cunet = values.cunetID === '1'
        const isPhD = values.isPhD || false
        const format = {
            ...values,
            title: {
                id: values.titleID,
                name: {
                    th: values.titleOther,
                    en: values.titleOther,
                },
            },
            position: {
                id: values.positionID,
                name: {
                    th: values.positionOther,
                    en: values.positionOther,
                },
            },
            cunet,
            isPhD,
            signatureTH: values?.signatureTH ?? [],
            signatureEN: values?.signatureEN ?? [],
            documentInfo: [...values?.documentInfo[0]?.uploadFileObj?.fileList],
            updatedBy: authenStore.profile.userId,
        }
        const result = await putOfficer(format, params.id)

        if (result) {
            if (result.status === 1) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.NOTIFICATION'),
                    content: translate.get('ALERT.CONTENT.SAVE_SUCCESS'),
                    type: 'alert-message',
                    onAfterClose: onBack,
                })
                dialogTwoRef.current?.openDialog()
            } else if (result.status === -2) {
                setConfigDialog({
                    title: translate.get('ALERT.TITLE.WARNING'),
                    content: translate.get('ALERT.CONTENT.DUPLICATE_GROUP_USER'),
                    type: 'alert-message',
                })
            }
        } else {
            setConfigDialog({
                title: translate.get('ALERT.TITLE.ERROR'),
                content: translate.get('ALERT.CONTENT.SAVE_NOT_SUCCESS'),
                type: 'alert-message',
            })
        }
    }
    const onSubmit = async (values: FormType) => {
        setConfigDialog({
            title: translate.get('ALERT.TITLE.NOTIFICATION'),
            content: translate.get('ALERT.CONTENT.NEED_TO_SAVE'),
            type: 'alert-confirm',
            onClickConfirm: () => save(values),
        })

        dialogTwoRef.current?.openDialog()
    }

    const onBack = () => {
        history.goBack()
    }

    const onChangeMobilePhone = (val: string, fnCallback: (valBack: string) => void) => {
        if (val) {
            fnCallback(val.replace(/[^\d]/g, '').slice(0, 20))
        }
    }

    useEffect(() => {
        initialUpload(officerInfo?.documentInfo)
    }, [officerInfo])
    return (
        <Container maxWidth="lg">
            <Grid container justify="center" alignContent="center" className={classes.root}>
                {/* <Grid item xs={12} md={10} lg={8} className={classes.item}> */}
                <Grid item xs={12}>
                    <Typography variant="h5" style={{ fontWeight: 'bold' }}>
                        {translate.get('UM.USERGROUP-ADD.TITLE_EDIT')}
                    </Typography>
                </Grid>
                <Paper className={classes.paper}>
                    <Form
                        onClickSubmit={onSubmit}
                        onChangeMobilePhone={onChangeMobilePhone}
                        onClickBackLink={onBack}
                        initialValue={initialValue}
                        mode="edit"
                        topicInitial={topicInitial}
                        initialUploadFile={initialUploadFile}
                        //readonly
                    />
                    <Dialog onRef={onRefDialogTwo} {...configDialog} />
                </Paper>
                {/* </Grid> */}
            </Grid>
            <Dialog onRef={onRefDialogTwo} {...configDialog} />
        </Container>
    )
}

const useStyles = makeStyles((theme) => ({
    root: {
        width: '100%',
        height: '100%',
    },
    container: {
        padding: '24px',
        borderRadius: '8px',
    },
    item: {
        position: 'absolute',
    },
    paper: {
        width: '100%',
        margin: '2rem 0px',

        [theme.breakpoints.down('sm')]: {
            backgroundColor: 'unset',
            boxShadow: 'unset',
            margin: '0px',
        },
    },
}))

export default UsergroupAdd
